import { MessageStateEnum, TestStatusEnum } from './test-group.model';

export interface CreateSharedLinkRequestDto {
  testType: SharedTestType;
  testIds: number[];
}

export interface CreateSharedLinkResponse {
  token: string;
  expireAt: string | Date;
  testsCount: number;
}

export enum SharedTestType {
  LNT = 'LNT',
  MNT = 'MNT',
}

export interface SharedLinkTestResultInfo {
  id: number;
  createdAt: string | Date;
  testStatus: TestStatusEnum;
  messageState: MessageStateEnum | null;
  channel: string;
  senderDelivered: string;
  senderSent: string | null;
  textDelivered: string;
  textDeliveredFull: string | null;
  textSent: string | null;
  telqId: string;
  textSentBackend?: string | null;
  // destination info
  destinationPhoneMasked: string | null;
  destinationMnc: string | null;
  destinationMcc: string | null;
  destinationCountryName: string | null;
  destinationProviderName: string | null;
  destinationOriginalMnc: string | null;
  destinationOriginalProviderName: string | null;
  // smsc info
  smscPhoneMasked: string | null;
  smscCountryName: string | null;
  smscCountryCode: string | null;
  companyName: string | null;
  smppDelay: number | null;
  receiptDelay: number;
}

export interface SharedTestsResultsResponse {
  expireAt: string | Date;
  testType: SharedTestType;
  testsResults: SharedLinkTestResultInfo[];
}

export type SharedTestsLinkErrorType = 'notFound' | 'expired' | 'invalid' | 'unknown';
